import { WarningLevel } from 'src/interfaces/attendance'

export const APP = {
  refreshTokenInSeconds: 60 * 30, // 30 mins
  refreshTokenPerSeconds: 60 * 5, // 5 mins
  allowableInactiveSeconds: 8 * 60 * 60, // 8 hours
  deviceCodeKey: 'deviceCode',
}

export const ApprovalStatus = {
  pending: 'pending',
  approved: 'approved',
}

export const FORMATE = {
  date: 'YYYY-MM-DD',
  year: 'YYYY',
  dateSlash: 'YYYY/MM/DD',
  monthAndDay: 'MM-DD',
  time: 'h:mm:ss A',
  shortTime: 'hh:mm A',
  datetime: 'YYYY-MM-DD hh:mm A',
  datetime2: 'YYYY-MM-DDTHH:mm:ss',
  humanreadable: 'MMM DD YYYY',
  humanreadableLongMonth: 'MMMM DD YYYY',
  dateTimeHumanReadable: 'MMM DD YYYY hh:mm A',
  defaultDate: 'YYYY/MM',
}

export const ENV = {
  DEV: 'DEV',
  UAT: 'UAT',
  PRD: 'PRD',
}

export const SERVICES = {
  attendance: 'cfattendanceservice',
  auth: 'cfcoreauthservice',
  client: 'cfcoreclientservice',
  mgmt: 'cfcoreauthservice',
  res: 'cfcoreresourceservice',
  pay: 'cfcorepaymentservice',
  payProcessing: 'cfpayprocessservice',
  ops: 'cfcoreoperationservice',
  learn: 'cflearningservice',
  sche: 'cfcorescheduleservice',
  pub: 'cfcorepublicservice',
  per: 'cfcorepersonnelservice',
  agg: 'cfcoreaggregateservice',
  form: 'cfcoreformservice',
  file: 'cfcorefileservice',
  event: 'cfcoreeventservice',
  notification: 'cfnotificationservice',
  signalR: 'cfcoresignalrservice',
  report: 'cfreportingservice',
  upload: 'cfuploadservice',
}

export const ENROLLMENTSTATUS = {
  Complete: 'Complete',
  Waitlist: 'Waitlist',
  Deny: 'Deny',
  EndingEnrollmentComplete: 'Ending-Enrollment-Complete',
}

export const APIS = {
  absence: 'absence',
  accounts: 'accounts',
  acknowledge: 'acknowledge',
  acknowledged: 'acknowledged',
  activeCampaign: 'activeCampaign',
  add: 'add',
  adjustmentExpiries: 'adjustmentExpiries',
  adjustments: 'adjustments',
  ageDictionary: 'ageDictionary',
  agreementsAndPolicies: 'agreementsAndPolicies',
  approve: 'approve',
  attendance: 'attendances',
  attendanceTeams: 'attendances/teams',
  attendeeLogs: 'attendeeLogs',
  attendees: 'attendees',
  auth: 'auth',
  authorizedDeviceAccess: 'authorizedDeviceAccess',
  authorizedMembers: 'authorizedMembers',
  billings: 'billings',
  calendars: 'calendars',
  center: 'center',
  centerFinancials: 'centerFinancials',
  centers: 'centers',
  certifications: 'certifications',
  cfInvoices: 'cfInvoices',
  cfPayments: 'cfPayments',
  check: 'check',
  CheckADFPipelineRunStatus: 'CheckADFPipelineRunStatus',
  checkIn: 'checkIn',
  checkOut: 'checkOut',
  clientOnboarding: 'clientOnboarding',
  clientUsers: 'clientusers',
  clone: 'clone',
  config: 'config',
  connect: 'connect',
  convertTimeFromCurrentUTC: 'convertTimeFromCurrentUTC',
  ConvertTimeToUTC: 'ConvertTimeToUTC',
  copy: 'copy',
  createAdminStaff: 'createAdminStaff',
  createOrgInfo: 'createOrgInfo',
  creditRefund: 'creditRefund',
  csv: 'csv',
  curriculum: 'curriculum',
  customBilling: 'customBilling',
  customFields: 'customFields',
  customForm: 'forms/custom',
  customFormTemplate: 'forms/custom/templates',
  customQuestions: 'customQuestions',
  customs: 'custom',
  dashboard: 'dashboard',
  depositGroupsSettle: 'deposits/settle',
  deposits: 'deposits',
  deviceAuthorization: 'deviceAuthorization',
  deviceRegister: 'devices/register',
  deviceUnregisterByDeviceId: 'devices/unregister/device',
  disconnect: 'disconnect',
  discounts: 'orgInfo/discounts',
  discoveryTopic: 'discoveryTopic',
  domain: 'domain',
  domains: 'domains',
  domainAuth: 'domainAuth',
  dropInRoster: 'dropInRoster',
  dropOff: 'dropOff',
  editOrgInfo: 'editOrgInfo',
  emailHistoryList: 'emailHistoryList',
  emailMissingOnboardingInformation: 'emailMissingOnboardingInformation',
  emails: 'emails',
  emergencyInfo: 'reports/emergencyInfo',
  enrollmentCustomFields: 'enrollmentCustomFields',
  enrollments: 'enrollments',
  events: 'events',
  failedCharges: 'failedCharges',
  families: 'families',
  familiesByIds: 'familiesByIds',
  family: 'family',
  familyBulkUpload: 'familyBulkUpload',
  featureFlag: 'featureFlag',
  file: 'file',
  files: 'files',
  flaggedMembers: 'flaggedMembers',
  focusArea: 'focusArea',
  folders: 'folders',
  form: 'forms',
  getattendancelogreport: 'getattendancelogreport',
  groupedSettlement: 'groupedSettlement',
  groups: 'groups',
  growthIndicator: 'growthIndicator',
  hiddenExpiriesEvents: 'hiddenExpiriesEvents',
  holidayPayStrategy: 'holiday-pay-strategy',
  holidays: 'holidays',
  ical: 'ical',
  import: 'import',
  importers: 'importers',
  inactiveStudents: 'inactiveStudents',
  infoChanges: 'infoChanges',
  invoices: 'invoices',
  itemCatalog: 'orgInfo/itemCatalogs',
  journals: 'journals',
  kiosk: 'kiosk',
  kioskSettings: 'kioskSettings',
  learningOutcome: 'learningOutcome',
  lesson: 'lesson',
  lessonPlans: 'lessonPlans',
  library: 'library',
  locations: 'orgInfo/locations',
  login: 'login',
  logs: 'logs',
  manualPayment: 'manualPayment',
  manualPayments: 'manualPayments',
  marketplace: 'marketplace',
  mealAdjustments: 'orgInfo/mealAdjustments',
  memberListForVolunteerExpiary: 'memberListForVolunteerExpiary',
  members: 'members',
  messages: 'messages',
  mixedTeamRatioRules: 'mixedTeamRatioRules',
  monthlyClaims: 'monthlyClaims',
  mute: 'mute',
  napTime: 'napTime',
  negotiate: 'negotiate',
  notifications: 'notifications',
  inapp: 'inapp',
  count: 'count',
  clear: 'clear',
  clearAll: 'clear-all',
  undo: 'undo',
  undoClearAll: 'undo-clear-all',
  notificationSettings: 'notificationSettings',
  oneTimePasscode: 'oneTimePasscode',
  org: 'org',
  orgInfo: 'orgInfo',
  orgInfoList: 'orgInfoList',
  orgs: 'orgs',
  override: 'override',
  partner: 'partner',
  paymentGroups: 'paymentGroups',
  payments: 'payments',
  permissionConsent: 'permissionConsent',
  photo: 'photo',
  photos: 'photos',
  pin: 'PIN',
  pins: 'pins',
  pods: 'pods',
  preferences: 'preferences',
  processing: 'processing',
  programs: 'programs',
  public: 'public',
  publicRegistrations: 'publicRegistrations',
  push: 'push',
  quickBooks: 'QuickBooks',
  rates: 'rates',
  receivablePayments: 'receivablePayments',
  refresh: 'refresh',
  registrationProposal: 'registrationproposal',
  registrations: 'registrations',
  registrationStatus: 'registrationStatus',
  reject: 'reject',
  remove: 'remove',
  requestApproval: 'requestApproval',
  rotessaConfig: 'payments/config',
  route: 'route',
  routine: 'routine',
  RunADFPipeline: 'RunADFPipeline',
  schools: 'schools',
  search: 'search',
  searchStaff: 'searchStaff',
  sessions: 'sessions',
  settings: 'settings',
  settle: 'settle',
  settlement: 'settlement',
  shared: 'shared',
  shareTokens: 'shareTokens',
  signature: 'signature',
  signedAgreementsAndPolicies: 'signedAgreementsAndPolicies',
  signIn: 'signIn',
  signOut: 'signOut',
  spaces: 'spaces',
  sponsor: 'sponsor',
  sponsors: 'orgInfo/sponsors',
  staff: 'staff',
  staffRoles: 'staffRoles',
  staffs: 'staffs',
  storedEmails: 'storedEmails',
  studentDirectory: 'studentDirectory',
  studentMedicationRecords: 'studentMedicationRecords',
  studentPausedPickup: 'studentPausedPickup',
  studentPublicRegistrations: 'studentPublicRegistrations',
  students: 'students',
  studentsByIds: 'studentsByIds',
  studentsHavingMedications: 'studentsHavingMedications',
  subuser: 'subuser',
  sync: 'sync',
  tasks: 'orgInfo/tasks',
  teamRatioRule: 'teamRatioRules',
  teams: 'teams',
  thirdPartyAllocations: 'thirdPartyAllocations',
  token: 'token',
  transports: 'transports',
  tree: 'tree',
  unacknowledged: 'unacknowledged',
  updateEnrollmentStatus: 'updateEnrollmentStatus',
  updateStudentLastMedicationComplete: 'updateStudentLastMedicationComplete',
  updateWaitlistPriority: 'updateWaitlistPriority',
  user: 'user',
  userCredentials: 'user/credentials',
  userPassword: 'users/password',
  users: 'users',
  validate: 'validate',
  verifyEmail: 'verifyEmail',
  versions: 'versions',

  // reports
  reports: 'reports',
  rosterRpt: 'reports/rosterDetails',
  licenseSummaryRpt: 'licenseSummary',
  groupSummaryRpt: 'groupSummary',
  studentStartingRpt: 'reports/studentStarting',
  studentChangingRpt: 'reports/studentChanges',
  studentEndingRpt: 'reports/studentEnding',
  mealRestrictRpt: 'reports/mealRestrict',
  medLogRpt: 'reports/medLog',
  incidentlogRpt: 'reports/incidentLog',
  illnesslogRpt: 'reports/illnessLog',
  medicalCareRpt: 'reports/medicalCare',
  studentDirectoryRpt: 'studentDirectory',
  studentBirthdayRpt: 'reports/studentBirthday',
  studentAgeChangeRpt: 'reports/studentAgeChanges',
  staffDirectoryRpt: 'staffDirectory',
  staffCertExpiryRpt: 'reports/staffCertificationExpiry',
  staffBirthdayRpt: 'reports/staffBirthday',
  hundredHrRpt: 'reports/ab100Hr',
  hundredHrRptDetails: '100HrRptDetails',
  preschoolDaysRpt: 'reports/abPreschoolDays',
  preschoolDaysRptDetails: 'preschoolDaysRptDetails',
  revPaySummaryRpt: 'revPaySummaryReport',
  feesRecordRpt: 'feesRecordReport',
  ARThirdpartyRpt: 'arThirdPartyReport',
  transactionReport: 'transactionReport',
  studentSummaryRpt: 'studentSummaryRpt',
  staffuser: 'staffuser',
  supportedVersions: 'supportedVersions',
  dailyStaffHoursSummary: 'dailyStaffHoursSummary',
  dailyStudentHoursSummary: 'dailyStudentHoursSummary',
  payroll: 'payroll',
  staffSignInDetail: 'staffSignInDetail',
  studentSignInDetail: 'studentSignInDetail',
  subsidyClaim: 'subsidyClaim',
  abClaims: 'abClaims',
  supplementalParentFees: 'supplementalParentFees',

  // configs
  userConfig: 'config/user',
  orgConfig: 'config/org',
  centerConfig: 'config/center',
}

export const QUICKBOOKS = {
  name: 'QuickBooks',
  callbackPath: '/callback/QuickBooks',
}

export const METHODS = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE',
  patch: 'PATCH',
}

export const STATUS_CODES = {
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  notFound: 404,
  gone: 410,
  internalError: 500,
}

export const COMMON_KEYS = {
  appJson: 'application/json',
  contentType: 'content-type',
  feeCollectionDateFilter: 'feeCollectionDateFilter',
  language: 'language',
  darkMode: 'darkMode',
}

export const ERROR_TYPES = {
  internalError: 'internalError',
  notFoundError: 'notFoundError',
  unknownError: 'unknownError',
  validationError: 'validationError',
  networkError: 'networkError',
}

export const ATTENDEE_TYPES = {
  staff: 'staff',
  student: 'student',
}

export const ATTENDANCE_TYPES = {
  signIn: 'SignIn',
  signOut: 'SignOut',
  move: 'Move',
}

export const VERSIONS = {
  v1: 'v1',
  v2: 'v2',
}

export const LOADERS = {
  cli: 'cli',
  agg: 'agg',
  att: 'att',
  attendance: 'attendance',
  per: 'per',
  res: 'res',
  file: 'file',
  public: 'public',
  payProcessing: 'payProcessing',
  family: 'family',
  form: 'form',
  importer: 'importer',
  learn: 'learning',
  space: 'space',
  payment: 'payment',
  group: 'group',
  transport: 'transport',
  rate: 'rate',
  program: 'program',
  location: 'location',
  event: 'event',
  mgmt: 'mgmt',
  report: 'report',
  upload: 'upload',
  notification: 'notification',
  signalR: 'signalR',
}

export const SIGNAL_R_MESSAGES = {
  updatedFamily: 'updatefamily',
  updatedStaff: 'updatestaff',
  updatedRegistration: 'updateregistration',
  updatedProcessing: 'updateprocessing',
  updatedSettlement: 'updatesettlement',
  getAdminUnreadMessages: 'getAdminUnreadMessages',
  getParentPortalUnreadMessages: 'getParentPortalUnreadMessages',
  getAttendance: 'getAttendance',
  getMedicationList: 'getMedicationList',
  newNotification: 'newNotification',
  clearedNotification: 'clearedNotification',
}

export const daysOfWeek = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]
export const daysOfWeekSundayFirst = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
]
export const months = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
]

export const LINE_ITEM_TYPES = {
  discount: 'Discount',
  charge: 'Charge',
}

export const BLOB_ACTIONS = {
  move: 'move',
  rename: 'rename',
  create: 'create',
  delete: 'delete',
}

export const GradeOrder = {
  move: 'move',
  rename: 'rename',
  create: 'create',
  delete: 'delete',
}

export const LAST_UPDATE_ANIM_TIMEOUT = 800

export const TEMPLATE_TYPES = {
  family: 'family',
  staff: 'staff',
  student: 'student',
}

export const LICENSES = {
  oosc: 'OOSC',
  daycare: 'Daycare',
}

export const AGE_RANGE_TYPES = {
  age: 'Age',
  grade: 'Grade',
}

export const REG_STATUS = {
  onboarding: 'Onboarding',
  active: 'Active',
  past: 'Past',
  pending: 'Pending',
  waitlisted: 'Waitlist',
  current: 'Current',
  registered: 'Registered',
  next: 'Next',
  future: 'Future',
  cancelled: 'Cancelled',
}

export const SponsorTypes = {
  unassigned: 'Unassigned',
  external: 'External',
  personal: 'Personal',
  anonymous: 'Anonymous',
}

export const PAYMENT_STATUS = {
  processing: 'Processing',
  processed: 'Processed',
  deposited: 'Deposited',
  settled: 'Settled',
  rejected: 'Rejected',
  close: 'Close',
  chargeback: 'Chargeback',
}

export const PAYMENT_METHOD = {
  pad: 'Pad',
  cash: 'Cash',
  check: 'Check',
  interac: 'Interac',
  creditCard: 'Credit Card',
  emailTransfer: 'Email Transfer',
  etf: 'ETF',
  credit: 'Credit',
}

export default {
  LICENSES,
}

export const RATE_CREDIT_TYPE = {
  daysPerWeek: 'Days per week',
}

export const RATE_CREDIT_STYLE = {
  fullTime: 'Full Time',
  partTime: 'Part Time',
  dropIn: 'Drop In',
}

export const STUDENT_STATUS = {
  pending: 'Pending',
  current: 'Current',
  future: 'Future',
  past: 'Past',
  inactive: 'Inactive',
}

export const STUDENT_SUB_STATUS = {
  onboarding: 'Onboarding',
  waitlist: 'Waitlist',
  toWithdraw: 'ToWithdraw',
  withdrawn: 'Withdrawn',
  toEnd: 'ToEnd',
  ended: 'Ended',
  completed: 'Completed',
}

export const IS_SCHOOL_REQUIRED_OPTIONS = {
  yes: 'Yes',
  no: 'No',
  optional: 'Optional',
}

export const GRADE_MAP: { [index: string]: number } = {
  Preschool: 0,
  Kindergarten: 1,
  'Grade 1': 2,
  'Grade 2': 3,
  'Grade 3': 4,
  'Grade 4': 5,
  'Grade 5': 6,
  'Grade 6': 7,
  'Grade 7+': 8,
}

export const UPLOAD_STATUS = {
  error: 'Error Occurred',
  finished: 'Finished',
  inProgress: 'In Progress',
  incorrectTemplate: 'Error- incorrect template',
  emailMissing: 'Error- Missing Email(s)',
}

export const USER_TYPES = {
  member: 'Member',
  student: 'Student',
}

export const INVOICE_STATUSES = {
  open: 'Open',
  processed: 'Processed',
  processing: 'Processing',
  deposited: 'Deposited',
  settled: 'Settled',
  close: 'Close',
}

export const SETTLEMENT_TAB_LABELS = {
  processed: { value: 'Processed', label: 'Processed' },
  deposited: { value: 'Deposited', label: 'Deposited' },
  settled: { value: 'Settled', label: 'Settled' },
}

export const MedicationDueMinutes = 15
export const PUBLIC_REGISTRATION_TYPE = {
  family: 'Family',
  student: 'Student',
}

export const ACTIVITY_TYPES = [
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'Learning',
    value: 'Learning',
  },
  {
    label: 'Activity',
    value: 'Activity',
  },
  {
    label: 'Achievement',
    value: 'Achievement',
  },
  {
    label: 'Observations',
    value: 'Observations',
  },
  {
    label: 'Food',
    value: 'Food',
  },
  {
    label: 'Potty',
    value: 'Potty',
  },
  {
    label: 'Nap',
    value: 'Nap',
  },
  {
    label: 'Health',
    value: 'Health',
  },
  {
    label: 'Meds (Emergency/As Needed)',
    value: 'Meds',
  },
  {
    label: 'Incident',
    value: 'Incident',
  },
  {
    label: 'Meeting',
    value: 'Meeting',
  },
  {
    label: 'Notes',
    value: 'Notes',
  },
]

export const paymentColorMap: Record<string, string> = {
  Processing: 'grey-5',
  Settled: 'primary',
  Deposited: 'primary',
  Rejected: 'negative',
  Chargeback: 'red-5',
  Recovery: 'purple-8',
}

export const TabOptions = {
  active: 'Active',
  archived: 'Archived',
}

export const DefaultTabOptions = [TabOptions.active]

export const AgreementAndPolicyTypes = {
  mandatory: 'Mandatory',
  optional: 'Optional',
}

export const AgreementAndPolicyCategories = {
  registration: 'Registration',
}

export const InvoiceTypes = {
  normal: 'normal',
  reversal: 'reversal',
  recovery: 'recovery',
  merchantFee: 'merchant fee',
}

export const DepositGroupStatuses = {
  deposited: 'Deposited',
  settled: 'Settled',
}

export const MemberTypes = {
  legalGuardian: 'Legal Guardian',
  nonGuardianEmergencyContact: 'Non-Guardian Emergency Contact',
  other: 'Other',
}

export const StudentTagList = {
  basicInfo: 'Basic Info',
  healthcareInfo: 'Healthcare Info',
  emergencyContactInfo: 'Emergency Contact Info',
  legalGuardian: 'Legal Guardian',
  nonGuardianEmergencyContact: 'Non-Guardian Emergency Contact',
  autoInvoicing: 'Auto Invoicing',
  agreement: 'Agreement',
  waitlist: 'Waitlist',
  toWithdraw: 'To Withdraw',
  withdrawn: 'Withdrawn',
  toEnd: 'To End',
  ended: 'Ended',
  endingEnrollmentComplete: 'Ending-Enrollment-Complete',
}

export const StudentTagRequirementLevel = {
  required: 'Required',
  recommended: 'Recommended',
  na: 'N/A',
}

export const PaymentSources = {
  stripe: 'stripe',
  rotessa: 'rotessa',
}

export const BalanceStatuses = [
  'Credit Balance',
  'Zero',
  'Outstanding',
  '1 Month Past Due',
  '2 Months Past Due',
  '3+ Months Past Due',
]

export const AttendanceWarningColorMap = (isFloorMap?: boolean) => {
  return {
    'Exceeds max team size': WarningLevel.Negative,
    'Exceeds team ratio': WarningLevel.Negative,
    'Exceeds space max capacity': WarningLevel.Negative,
    'Missing permitted use': WarningLevel.Negative,
    'Missing staff': WarningLevel.Negative,
    'Missing team ratio': WarningLevel.Negative,
    'Forbidden age group detected': WarningLevel.Negative,
    'Mixed license': WarningLevel.Warning,
    'Extra staff': WarningLevel.Positive,
    ...(!isFloorMap && { Napping: WarningLevel.Warning }),
  } as { [index: string]: WarningLevel }
}

export const LineItemNames = {
  appliedCredits: 'Applied Credits',
  rejectedPayment: 'Rejected Payment',
  bouncedPayment: 'Bounced Payment',
}

export const AGE_GROUP_ICONS = {
  zeroToSixMonths: 'child_care',
  sixToTwelveMonths: 'child_care',
  twelveToTwentyFourMonths: 'child_care',
  twentyFourToThirtySixMonths: 'face',
  thirtySixToFourtyEightMonths: 'face',
  fourtyEightToSixtyMonths: 'face',
  kindergarten: 'school',
  beforeOrAfterSchool: 'schedule',
}

export interface OptionProp {
  label: string
  offset: number
  color: string
}

export const WEEKLY_QUICK_SELECT = [
  { label: 'This Week', offset: 0, color: 'primary' },
  { label: 'Next Week', offset: 1, color: 'positive' },
  { label: 'Week After', offset: 2, color: 'secondary-green' },
] as OptionProp[]
